import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddInvoiceFormStyle from './css/AddInvoiceFormStyle'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import Searchbar from '../../../layout/searchbar/Searchbar'
import { trackPromise } from 'react-promise-tracker'
import axios from 'axios'
import {formatNumber} from '../../../utilities/utilities'

const useAddInvoiceForm = (props) => {
  const { app, customerAccount, creditAccount, addInvoices } = props
  const [invoiceList, setInvoiceList] = useState(null)
  const [invoiceListCopy, setInvoiceListCopy] = useState(null)

  const getUnpaidInvoices = async (silent=false) => {
    let unpaid_invoices = null
    app.startLoadingIndicator()
    await trackPromise (
      axios.get(app.API_URI + '/invoices?status=Unpaid') // Queried only Unpaid invoices
        .then(result => {
          if (!silent) {
            setInvoiceList(result.data)
            setInvoiceListCopy(result.data)
          }
          unpaid_invoices = result.data
          app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return(unpaid_invoices)
  }

  const filterInvoiceList = (searchString) => {
    let tempList = []
    invoiceListCopy.forEach((invoice, i) => {
      invoice.searchable_string = `${invoice._id} ${invoice.customer_details.sold_to} ${invoice.prepared_by}`
    })

    invoiceListCopy.forEach(invoice => {
      let found = true
      searchString.split(' ').forEach((search_string_item, i) => {
        found = (found && (invoice.searchable_string.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
      })
      if (found) tempList.push(invoice)
    })

    setInvoiceList(tempList)
  }

  const updateInvoice = async (invoice) => {
    invoice.status = 'Linked'
    invoice.customer_account_link = {
      customer_account_id: customerAccount._id,
      credit_account_number: creditAccount.credit_account_number
    }

    let updated_invoice = null
    invoice.signed_in = app.client.signed_in

    app.startLoadingIndicator("Updating Invoice")
    axios.put(app.API_URI + `/invoices?invoice_id=${invoice._id}`, invoice)
    .then(result => {
      //if (result.data.status === 1) updated_invoice = result.data.data
      updated_invoice = result.data
      ReactDOM.unmountComponentAtNode(document.getElementById('loading-indicator-container'))
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
    return (updated_invoice)
  }

  useEffect(() => {
    const init = async () => { await getUnpaidInvoices() }
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    addInvoices,
    updateInvoice,
    invoiceList,
    filterInvoiceList,
    getUnpaidInvoices,
    app
  })
}

function AddInvoiceForm(props) {
  const { app, addInvoices, updateInvoice, invoiceList, filterInvoiceList, getUnpaidInvoices } = useAddInvoiceForm(props)
  const [searchInput, setSearchInput] = useState(null)
  const [selectedInvoicesID, setSelectedInvoicesID] = useState([])

  const onClickCancel = (e) => {
    // Close this form
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  const onClickApply = async (e) => {
    const unpaid_invoices = await getUnpaidInvoices(true)
    const selected_invoices = []
    const invoicesNotFound = []

    const showInvoiceNotFoundMessageBox = () => {
      ReactDOM.render(
        <ModalWindow
          id='mw-child'
          height='30'
          width='35'
          header="Invoice's not found"
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <p>Some selected Invoice's are no longer available.</p>
                <br />
                <br />
              </div>
              <div className='button-container'>
                <button
                  onClick={() => {
                    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
                  }}
                  className='pospro-action-btn top-anchor'>
                  Ok
                </button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('mw-parent')
      )
    }

    selectedInvoicesID.forEach((invoice_id, i) => {
      const invoice = unpaid_invoices.find(ui => ui._id === invoice_id)
      if (invoice) {
        selected_invoices.push({
          date_added: app.getClientDateTime(), 
          client_timezone: app.getClientTimezone(),
          invoice_number: invoice._id,
          invoice_date: invoice.invoice_date,
          invoice_client_timezone: invoice.client_timezone,
          sold_to: invoice.customer_details.sold_to,
          invoice_summary: invoice.invoice_summary
        })
        // Update this Invoice state to 'Linked' in the database
        updateInvoice(invoice)
      } else invoicesNotFound.push(invoice_id)
    })
    addInvoices(selected_invoices)
    if (invoicesNotFound.length > 0) { showInvoiceNotFoundMessageBox() }
    else onClickCancel()
  }

  const onClickInvoice = (e) => {
    const invoiceContainer = e.target.closest('.unpaid-invoice-container')
    const checkMark = invoiceContainer.querySelector('.check-mark')
    if (checkMark.classList.contains('show-check-mark')) {
      // Remove invoice
      setSelectedInvoicesID(selectedInvoicesID.filter(si => si !== invoiceContainer.id))
      checkMark.classList.remove('show-check-mark')
    } else {
      // Add invoice
      setSelectedInvoicesID([...selectedInvoicesID, invoiceContainer.id])
      checkMark.classList.add('show-check-mark')
    }
  }

  const searchbarProps = {
    search: searchInput,
    setSearch: setSearchInput,
    filter: filterInvoiceList
  }

  return (
    <div className='form-container'>
      <div className='form-title'>Select Unpaid Invoice's</div>
      <div style={{marginBottom: '10px'}}> <Searchbar { ...searchbarProps }/> </div>
      <section className='unpaid-invoice-list-container'>
      {
        invoiceList ?
          invoiceList.map((invoice, index)=> (
            <button
              key={invoice._id}
              id={invoice._id}
              className='unpaid-invoice-container'
              onClick={onClickInvoice} >
              <div className='unpaid-invoice-item-container'>
                <div className='unpaid-invoice-item'>
                  <div className='unpaid-invoice-item-label'>Invoice Date</div>
                  <div className='unpaid-invoice-item-data'>{`${new Date(invoice.date_time_created).toLocaleString("en-us", { timeZone: invoice.client_timezone })} ${invoice.client_timezone}`}</div>
                </div>
                <div className='unpaid-invoice-item'>
                  <div className='unpaid-invoice-item-label'>Invoice Number</div>
                  <div className='unpaid-invoice-item-data'>{invoice._id.toUpperCase()}</div>
                </div>
                <div className='unpaid-invoice-item'>
                  <div className='unpaid-invoice-item-label'>Sold To</div>
                  <div className='unpaid-invoice-item-data'>{invoice.customer_details.sold_to}</div>
                </div>
                <div className='unpaid-invoice-item'>
                  <div className='unpaid-invoice-item-label'>Invoice Amount</div>
                  <div className='unpaid-invoice-item-data'>P{formatNumber(parseFloat(invoice.invoice_summary.total_sales))}</div>
                </div>
                <div className='unpaid-invoice-item'>
                  <div className='unpaid-invoice-item-label'>Prepared By</div>
                  <div className='unpaid-invoice-item-data'>{invoice.prepared_by}</div>
                </div>
              </div>
              <div className='check-mark-container'>
                <div className='check-mark'>
                  <FontAwesomeIcon icon='check'/>
                </div>
              </div>
            </button>
          ))
        : <div id='loading-and-error-container'>
            <span>Loading invoices. Please wait...</span>
          </div>
      }
      </section>
      <div className='action-buttons-container'>
        <button
          onClick={onClickCancel}
          className='pospro-action-btn'>
          Cancel
        </button>
        <button
          disabled={!selectedInvoicesID.length}
          onClick={onClickApply}
          className={!selectedInvoicesID.length ? 'pospro-action-btn bottom-anchor disabled-button' : 'pospro-action-btn bottom-anchor'}>
          Apply
        </button>
      </div>
      <AddInvoiceFormStyle />
    </div>
  )
}

export default React.memo(AddInvoiceForm)